/**
 * CLI entry point - starts the Nexus server.
 *
 * Loads OTel instrumentation BEFORE Express/Knex if OTEL_ENABLED=true.
 * Use index.ts for library imports (import { start } from '@gzl10/nexus-backend').
 */

// Load .env first
import './env-loader.js'

// Init OTel BEFORE importing Express/Knex (must happen first for ESM patching)
import { getOtelConfig } from './modules/observability/observability.config.js'

if (getOtelConfig().enabled) {
  await import('./instrumentation.js')
}

// Now import and start the server (Hono, after OTel hooks)
const { start } = await import('./http/start.js')
try {
  await start()
} catch (err) {
  // Errors thrown during startup are already logged; surface a fatal line
  // and exit non-zero so process managers (PM2/systemd) restart us, but
  // skip if we've already received SIGTERM (graceful shutdown handler took over).
  console.error('[nexus] Fatal startup error:', err)
  process.exit(1)
}
